<p-carousel #carousel
            [value]="reminders"
            [numScroll]="5"
            [numVisible]="5"
            [circular]="true"
            [styleClass]="styleClass"
            [autoplayInterval]="autoPlayInterval"
            [responsiveOptions]="responsiveOptions">
    <ng-template let-reminder pTemplate="item">
        <reminder-card [reminder]="reminder"
                       (menuStatusChanged)="toggleAutoPlay(refreshEnabled = !$event)"
                       (onDetailsClicked)="goToReminderDetails(reminder)"
                       (onUpdate)="createPoll()">
        </reminder-card>
    </ng-template>
</p-carousel>